import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React, { forwardRef } from 'react';
import { element, string, oneOfType, arrayOf, node } from 'prop-types';
import { Container } from './flex.styles';
/**
 * Use the `Flex` component to control flex style.
 * see flexbox -> https://styled-system.com/api#flexbox
 */

const Flex = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    children
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["children"]);

  return /*#__PURE__*/React.createElement(Container, _extends({
    ref: ref
  }, props), children);
});
Flex.propTypes = {
  children: oneOfType([element, string, arrayOf(element), node])
};
Flex.defaultProps = {
  children: undefined
};
Flex.displayName = 'Flex';
export default Flex;